enum Category {
  insight = 'insight',
  intention = 'intention',
  belief = 'belief',
  question = 'question',
  milestone = 'milestone',
  gratitude = 'gratitude',
  idea = 'idea',
  dream = 'dream',
  principle = 'principle',
  desire = 'desire'
}

export type CategoryKey = keyof typeof Category;

export const categoryKeys: CategoryKey[] = Object.keys(Category) as CategoryKey[];

export const CATEGORY_LABELS = [
  { key: 'insight', label: 'Insights', caption: 'deep insights', color: '#bae3ba' },
  { key: 'intention', label: 'Plans', caption: 'plans and future intentions', color: '#f58220' },
  { key: 'belief', label: 'Beliefs', caption: 'core beliefs', color: '#89CFF0' },
  { key: 'question', label: 'Questions', caption: 'open questions and curiosity', color: '#b5b5f5' },
  { key: 'milestone', label: 'Milestones', caption: 'important life events', color: '#00fbff' },
  { key: 'gratitude', label: 'Gratitude', caption: 'thanks and gratitude', color: '#FFA07A' },
  { key: 'idea', label: 'Ideas', caption: 'great ideas and creative thoughts', color: '#198501' },
  { key: 'dream', label: 'Dreams', caption: 'dream journal', color: '#D8BFD8' },
  { key: 'principle', label: 'Principles', caption: 'guiding values to live by', color: '#4943f7' },
  { key: 'desire', label: 'Goals', caption: 'life goals and aspirations', color: '#FF7F7F' }
] as {
  key: CategoryKey;
  label: string;
  color: string;
  caption: string;
}[];

export type Nugget = {
  entryName: string;
  category: CategoryKey;
  content: string;
  tags: string[];
};

export type Entry = {
  entryName: string;
  tags: string[];
};

export const isNugget = (nug: any): nug is Nugget => {
  return (
    nug.entryName !== undefined && nug.category !== undefined && nug.content !== undefined && nug.tags !== undefined
  );
};

export const areNuggets = (nugs: any): nugs is Nugget[] => {
  return nugs.every((nug: any) => isNugget(nug));
};
